module.exports = __webpack_public_path__ + "img/drt16.27ec20ad.png";